"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[337],{

/***/ 65337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19010);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46133);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var _excluded = ["children"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var GlassBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  box-shadow: ", ";\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1rem;\n  background: ", ";\n  box-sizing: border-box;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.shadow;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.glassEffect.blur;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.glassEffect.blur;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.glassBackground;
});

var GlassBoxComponent = function GlassBoxComponent(_ref6) {
  var children = _ref6.children,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref6, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(GlassBox, _objectSpread(_objectSpread({
    padding: "1rem"
  }, props), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (GlassBoxComponent);

/***/ })

}]);